<!-- Event snippet for conversion page -->
<script>
  // Diferente tracking según el tipo de transacción
  var isSubscription = window.location.search.includes('type=subscription');
  
  if (isSubscription) {
    // Tracking para suscripciones
    gtag('event', 'conversion', {
        'send_to': 'AW-848469250/pEGxCPyJ4bMaEIK6ypQD',
        'value': 1.0,
        'currency': 'ARS',
        'transaction_id': '',
        'custom_parameters': {
          'transaction_type': 'subscription'
        }
    });
    
    fbq('track', 'Subscribe', {
      value: 1,
      currency: 'ARS'
    });
  } else {
    // Tracking para compras
    gtag('event', 'conversion', {
        'send_to': 'AW-848469250/pEGxCPyJ4bMaEIK6ypQD',
        'value': 1.0,
        'currency': 'ARS',
        'transaction_id': ''
    });

    fbq('track', 'Purchase', {
      value: 1,
      currency: 'ARS'
    });
  }
</script>

<section class="py-20 h-full">
  <div
    class="flex text-primary text-center items-center shadow-lg m-20 mt-0 p-10 justify-center"
  >
    <div class="">
      <img src="assets/pago_confirmado.png" class="" alt="" />
    </div>
    <div class="">
      <!-- Contenido para suscripciones -->
      <div *ngIf="isSubscription">
        <h1 class="text-3xl md:text-3xl font-bold pb-5">
          ¡Gracias por suscribirte!
        </h1>
        <p class="text-md font-light mb-6 pl-5">
          Tu suscripción ha sido activada exitosamente.<br />
          Recibirás un correo de confirmación con todos los detalles de tu suscripción<br />
          y las instrucciones para coordinar la instalación de tu equipo.
        </p>
        
        <!-- Información específica de Mercado Pago -->
        <div *ngIf="paymentMethod === 'mercado_pago'" class="bg-green-50 border border-green-200 rounded-lg p-4 mb-6 mx-5">
          <h3 class="text-lg font-semibold text-green-800 mb-2">✅ Suscripción Activada</h3>
          <p class="text-sm text-green-700 mb-2">
            Tu suscripción mensual está activa y se procesará automáticamente cada mes.
          </p>
          
        </div>

        <!-- Próximos pasos -->
        <div class="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 mx-5">
          <h3 class="text-lg font-semibold text-blue-800 mb-2">📋 Próximos pasos</h3>
          <ul class="text-sm text-blue-700 space-y-1">
            <li>• Nuestro equipo se pondrá en contacto contigo para coordinar la instalación</li>
            <li>• Recibirás un email con los detalles de tu suscripción</li>
            <li>• Podrás gestionar tu suscripción desde tu perfil de cliente</li>
          </ul>
        </div>
      </div>

      <!-- Contenido para compras -->
      <div *ngIf="!isSubscription">
        <h1 class="text-3xl md:text-3xl font-bold pb-5">
          ¡Recibimos tu pago!
        </h1>
        <p class="text-md font-light mb-10 pl-5">
          Procesamos tu pago correctamente.<br />
          Podrás consultar el estado de tu servicio desde tu perfil en <strong>Mis Servicios</strong>.<br />
          Cuando la factura esté disponible, podrás descargarla en <strong>Mis Facturas</strong>.
        </p>
      </div>

      <button
        class="bg-secondary text-sm font-medium px-4 py-1 rounded-full text-white items-center"
        routerLink="/clients"
      >
        Ir a mi perfil
      </button>
    </div>
  </div>
</section>
